import React, { CSSProperties, ReactNode, useEffect } from 'react';
import classNames from 'classnames';
import './index.scss';
import Abnormal from '@home/components/Abnormal';
import { dateAllFormat } from '@home/utils/common';

type MetricCardWrapProps = {
  className?: string;
  style?: CSSProperties;
  data: Record<string, any>;
  dataKey: string;
  // 是否只展示接口返回对应的指标
  onlyApiMetrics?: boolean;
  children?: ReactNode;
  [key: string]: any;
};

export default function MetricCardWrap(props: MetricCardWrapProps) {
  const { style,className, data: propsData, dataKey, children, onlyApiMetrics = false, height = 265, changeData, ...restProps } = props || {};
  const { data, loading, errorMsg: error } = propsData?.[dataKey] || {};
  const metricKeys = data ? Object.keys(data?.cards) : [];

  // 页面副标题, 更新时间
  useEffect(() => {
    changeData('subtitle', dateAllFormat(data?.update_date,"day") || "");
  }, [data]);

  return (
    <div className={classNames('dbd-metric-card-wrap', className)} style={style}>
      <Abnormal 
        isLoading ={loading}
        isError={error}
        isNoData={!data}
        classNames={"dbd-forecast-card-wrap-abnormal"}
        style={{backgroundColor: '#fff', height}}
        component={
          <div className="dbd-forecast-card-grid">
            {React.Children.map(children, (child: any) => {
              if (onlyApiMetrics && !metricKeys.includes(child?.props?.config?.props?.metricKey)) {
                return null;
              }
              return React.cloneElement(child, {
                ...restProps,
                data,
                error,
              });
            })}
          </div>
        }
      />
    </div>
  );
};
